import React from 'react'
import { Link, useNavigate } from 'react-router-dom'


const Footer = () => {
    const navigate = useNavigate();
  return ( 
    <div className='min-h-[50vh] bg-[#03236F] flex flex-col p-[6%] pr-[12%] text-nowrap'>
        <div className='flex flex-row w-full gap-[5%]'>
            <ul className='flex flex-col text-left justify-center gap-[5%]'>
                <img className='filter invert grayscale' src="logo.png" alt=""/>
                <img className='w-10' src="linkedin.png" alt=""/>

            </ul>
            <ul className='text-left'>
                <li className='m-1 text-lg font-bold  text-white mb-[30%]'>
                Services
                </li>
                <li onClick={() => navigate('/about-us')}  className='cursor-pointer m-1 text-lg text-white font-medium'>
                    Get A Project
                </li>
                <li onClick={() => navigate('/about-us')}  className='cursor-pointer m-1 text-lg text-white font-medium'>
                    Find A Project
                </li>
            </ul>
            <ul className='text-left'>
                <li className='m-1 text-lg font-bold  text-white mb-[20%]'>
                Categories
                </li>
                <li onClick={() => navigate('/about-us')}  className='cursor-pointer m-1 text-lg text-white font-medium'>
                    Mechanical Engineering
                </li>
                <li onClick={() => navigate('/services')} className='cursor-pointer m-1 text-lg text-white font-medium'>
                Electrical & Electronics
                </li>
                <li className='m-1 text-lg text-white font-medium'>
                    <Link  to="/privacy">Machinery</Link>
                </li>
                <li onClick={() => navigate('/blogs')} className='cursor-pointer m-1 text-lg text-white font-medium'>
                Automobile
                </li>
                <li onClick={() => navigate('/blogs')} className='cursor-pointer m-1 text-lg text-white font-medium'>
                Metallurgical
                </li>
            </ul>
            <ul className='text-left'>
                <li className='m-1 text-lg font-bold  text-white mb-[20%]'>
                About Us
                </li>
                <li onClick={() => navigate('/about-us')}  className='cursor-pointer m-1 text-lg text-white font-medium'>
                What is Jobb Work?
                </li>
                <li onClick={() => navigate('/services')} className='cursor-pointer m-1 text-lg text-white font-medium'>
                How Jobb Work Works?
                </li>
            </ul>
            <ul className='text-left'>
                <li className='m-1 text-lg font-bold  text-white mb-[20%] '>
                Contact Us
                </li>
                <li onClick={() => navigate('/about-us')}  className='cursor-pointer m-1 text-lg text-white font-medium pl-[4%]'>
                    <img src="bag-checked.png" alt=""/>
                </li>
                <li onClick={() => navigate('/about-us')}  className='cursor-pointer m-1 text-lg text-white font-medium pl-[4%]'>
                    <img src="email-multiple.png" alt=""/>
                </li>
            </ul>
            
        </div>
        <br/>
        <hr className='bg-white'/>
        <p className='self-end text-white'>copyright ©</p>
  

 

    </div>
  )
}

export default Footer